<ng-container
  [appTransition]="child"
  [show]="active()"
  [duration]="200"
  enter="transition-all"
  enterFrom="opacity-0"
  enterTo="opacity-100"
  leave="transition-all"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
  (afterLeave)="toEdit.set(null)"
>
  <div #child class="payment-modal-wrapper">
    <div class="payment-modal">
      <app-section title="Pagamento">
        <button class="close" (click)="active.set(false)">
          <span class="pi pi-times"></span>
        </button>
        <app-fields [formGroup]="paymentForm">
          <app-select
            [options]="yon"
            label="À vista"
            formControlName="aVista"
          ></app-select>
          <app-select
            [options]="meios"
            label="Método de pagamento"
            formControlName="meio"
          ></app-select>
          <app-input
            *ngIf="paymentForm?.get('meio')?.value === '99'"
            label="Outro"
            formControlName="descricaoMeio"
          ></app-input>
          <app-input
            type="currency"
            label="Valor"
            formControlName="valor"
          ></app-input>
        </app-fields>
      </app-section>
      <div class="submit">
        <app-button
          text="Salvar"
          (click)="save()"
          icon="pi pi-save"
        ></app-button>
      </div>
    </div>
  </div>
</ng-container>
<div class="payments">
  <app-payment-card
    [payment]="payment"
    *ngFor="let payment of payments()"
    (edit)="edit($event)"
  ></app-payment-card>
  <app-button
    (click)="openAddModal()"
    icon="pi pi-plus"
    text="Adicionar pagamento"
  ></app-button>
</div>
